<div *ngIf="alertMessage" 
     class="absolute top-4 right-4 z-50 border px-4 py-3 rounded mb-4 w-auto flex items-center"
     [ngClass]="{
       'bg-green-100 border-green-400 text-green-700': alertMessage.type === 'success',
       'bg-red-100 border-red-400 text-red-700': alertMessage.type === 'error',
       'bg-blue-100 border-blue-400 text-blue-700': alertMessage.type === 'info',
       'bg-yellow-100 border-yellow-400 text-yellow-700': alertMessage.type === 'warning'
     }" 
     role="alert">
  <div class="mr-2">
    <ng-container [ngSwitch]="alertMessage.type">
      <!-- Ícono para success -->
      <svg *ngSwitchCase="'success'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M5 13l4 4L19 7" />
      </svg>
      <!-- Ícono para error -->
      <svg *ngSwitchCase="'error'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
      </svg>
      <!-- Ícono para info -->
      <svg *ngSwitchCase="'info'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M13 16h-1v-4h-1m1-4h.01M12 20a8 8 0 100-16 8 8 0 000 16z" />
      </svg>
      <!-- Ícono para warning -->
      <svg *ngSwitchCase="'warning'" class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01M12 2a10 10 0 100 20 10 10 0 000-20z" />
      </svg>
      <!-- Por defecto, si se desea -->
      <svg *ngSwitchDefault class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8v4m0 4h.01" />
      </svg>
    </ng-container>
  </div>
  <span class="block sm:inline">{{ alertMessage.detail }}</span>
  <button type="button" (click)="clearAlert()" class="ml-4 text-xl font-bold leading-none focus:outline-none">
    <svg class="w-4 h-4" fill="currentColor" viewBox="0 0 20 20">
      <path fill-rule="evenodd" d="M10 8.586l4.95-4.95a1 1 0 111.414 1.414L11.414 10l4.95 4.95a1 1 0 01-1.414 1.414L10 11.414l-4.95 4.95a1 1 0 01-1.414-1.414L8.586 10l-4.95-4.95A1 1 0 015.05 3.636L10 8.586z" clip-rule="evenodd"></path>
    </svg>
  </button>
</div>

<ngx-spinner
  [name]="spinnerName"
  bdColor="rgba(0, 0, 0, 0.8)"
  size="medium"
  color="#fff"
  type="square-jelly-box"
  [fullScreen]="true">
  <p style="color: white"> Cargando... </p>
</ngx-spinner>
